import React, {useState, useEffect} from 'react'
import VerAprobados from './VerAprobados'
import SubirEditAprobado from './SubirEditAprobado'
import Eliminar  from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import {Titulos, peticionDelete} from '../hooks/Funciones'

const AprobadosAdmin = ({urlAprobados, titulo, urlCertificados}) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [aprobados, setAprobados] = useTraeDatos(urlAprobados)
	const TitulosPagina = ['Ver Actividades', 'Crear Actividades', 'Editar Actividad', 'Eliminar Actividad', 'Actividades']
	const [copiaArray, setCopiaArray] = useTraeDatos(urlAprobados)
	const [busqueda, setBusqueda] = useState('')

	const seleccionaRegistro = (dato, funcion) => e =>{
		setRegistroSelect({...dato, imagePrev: dato.imagen})
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const peticionDeletee = () =>{peticionDelete(registroSelect, urlAprobados, aprobados, setAprobados, setFuncion)}
	useEffect(() => {Titulos (funcion, setTituloPag, TitulosPagina)},[funcion])

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaArray.filter((item) => {
			if(item.nombre.toLowerCase().includes(termino.toLowerCase())){
				return item
			} 
		})
		setAprobados(resultado)
	}

	return(
		<div>
			<Header titulo={tituloPag} Agregar={false} funcion={funcion} setFuncion={setFuncion} Pagina={'aprobados'} RecibeBusqueda={RecibeBusqueda} busqueda={busqueda}/>
            {/* {funcion === 'crear' ?
                <SubirEditAprobado
					baseUrl={urlAprobados} 
					setFuncion={setFuncion}
					data={aprobados} 
					setData={setAprobados}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					funcion={funcion}/>
			:null} */}
			{funcion === 'editar' ?
				<SubirEditAprobado
					baseUrl={urlAprobados} 
					setFuncion={setFuncion}
					data={aprobados} 
					setData={setAprobados}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					registroSelect={registroSelect}
					funcion={funcion}
					urlCertificados={urlCertificados}/>
			:null}
			{funcion === 'ver' ?
				<VerAprobados
					data={aprobados} 
					seleccionaRegistro={seleccionaRegistro}
					setFuncion={setFuncion}
					setRegistroSelect={setRegistroSelect}
					baseUrl={urlAprobados}
				/>
			:null}
			{funcion === 'eliminar' ?
				<Eliminar 
					nombre={'Operador'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee}/>
				
			:null}
		</div>
	)
}

export default AprobadosAdmin